export default {
  breakpoints: {
    sm: "480px",
    md: "768px",
    lg: "960px",
  },
  colors: {
    background: "#fff",
    text: "#222",
    textLight: "#fff",
    primary: "#2c2f43",
    secondary: "#60c1de",
    secondaryLight: "#70deff",
  },
}
